import { Component, Input, forwardRef, TemplateRef, ViewChild } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FcinputComponent } from '../fcinput';
import { CommonService } from 'fccore2';
/**
 * fc-dateæ¥æ
 * 
 * è¾å¥æéæ©æ¥æçæ§ä»¶
 * 
 * å½ç¨æ·éè¦è¾å¥ä¸ä¸ªæ¥æï¼å¯ä»¥ç¹å»æ åè¾å¥æ¡ï¼å¼¹åºæ¥æé¢æ¿è¿è¡éæ©ã
 * 
 */
@Component({
    selector: 'fc-date',
    template: `
    <ng-template #fcbutton ><fc-button fcLabel="ç¡®å®" *ngIf="fcShowOk==='Y'" (click)="clickOk('clickOk',$event)"></fc-button></ng-template>
    <nz-date-picker *ngIf="fcShowLabel==='N'&&fcMode==='day'" [nzShowToday]="false" #dateObj [ngClass]="{'fc-readonly':_readonly===true,'fc-date-small':fcSize === 'small','fc-date-default':fcSize === 'default','fc-date-large':fcSize === 'large'}"
     [(ngModel)]="innerValue" [nzRenderExtraFooter]="fcbutton" (ngModelChange)="checkValidator($event)" [nzDisabledDate]="_disabledDate"  [nzAllowClear]="fcAllowClear==='Y'"
    [nzPlaceHolder]="fcPlaceHolder" [nzFormat]="fcFormat" [nzSize]="fcSize" [nzDisabled]="_disabled"  (blur)="_blur($event)" (focus)="_focus($event)"  (click)="_click($event)" (keyup)="_keyup($event)" ></nz-date-picker>
    <nz-year-picker *ngIf="fcShowLabel==='N'&&fcMode==='year'"  [ngClass]="{'fc-readonly':_readonly===true,'fc-date-small':fcSize === 'small','fc-date-default':fcSize === 'default','fc-date-large':fcSize === 'large'}"
     [(ngModel)]="innerValue" (ngModelChange)="checkValidator($event)" [nzDisabledDate]="_disabledDate"  [nzAllowClear]="fcAllowClear==='Y'" 
    [nzPlaceHolder]="fcPlaceHolder"   [nzSize]="fcSize" [nzDisabled]="_disabled"  (blur)="_blur($event)" (focus)="_focus($event)"  (click)="_click($event)" (keyup)="_keyup($event)" ></nz-year-picker >
    <nz-month-picker *ngIf="fcShowLabel==='N'&&fcMode==='month'"    [ngClass]="{'fc-readonly':_readonly===true,'fc-date-small':fcSize === 'small','fc-date-default':fcSize === 'default','fc-date-large':fcSize === 'large'}"
     [(ngModel)]="innerValue" (ngModelChange)="checkValidator($event)" [nzDisabledDate]="_disabledDate"   [nzAllowClear]="fcAllowClear==='Y'" 
    [nzPlaceHolder]="fcPlaceHolder" [nzFormat]="fcFormat" [nzSize]="fcSize" [nzDisabled]="_disabled"  (blur)="_blur($event)" (focus)="_focus($event)"  (click)="_click($event)" (keyup)="_keyup($event)" ></nz-month-picker>
    <div nz-row  nzType="flex" class="rowspans"  *ngIf="fcShowLabel===undefined||fcShowLabel==='Y'">
        <div nz-col [nzSpan]="labelSpan" class="labelspans"><span *ngIf="fcRequired==='Y'" style="color:red">*</span>{{fcLabel}}</div>
        <div nz-col [nzSpan]="valueSpan">
            <nz-year-picker style="width:100%;"   *ngIf="fcMode==='year'" [nzAllowClear]="fcAllowClear==='Y'" 
                 [ngClass]="{'fc-readonly':_readonly===true,'fc-date-small':fcSize === 'small','fc-date-default':fcSize === 'default','fc-date-large':fcSize === 'large'}" 
                 [(ngModel)]="innerValue" (ngModelChange)="checkValidator($event)" [nzDisabledDate]="_disabledDate"   [nzPlaceHolder]="fcPlaceHolder" 
                   [nzSize]="fcSize" [nzDisabled]="_disabled"  (blur)="_blur($event)" (focus)="_focus($event)"  (click)="_click($event)" (keyup)="_keyup($event)" ></nz-year-picker>
            <nz-month-picker style="width:100%;"   *ngIf="fcMode==='month'" [nzAllowClear]="fcAllowClear==='Y'" 
                [ngClass]="{'fc-readonly':_readonly===true,'fc-date-small':fcSize === 'small','fc-date-default':fcSize === 'default','fc-date-large':fcSize === 'large'}" 
                [(ngModel)]="innerValue" (ngModelChange)="checkValidator($event)" [nzDisabledDate]="_disabledDate"  
                [nzPlaceHolder]="fcPlaceHolder" [nzFormat]="fcFormat" [nzSize]="fcSize" 
                [nzDisabled]="_disabled"  (blur)="_blur($event)" (focus)="_focus($event)"  (click)="_click($event)" (keyup)="_keyup($event)" ></nz-month-picker>
            <nz-date-picker style="width:100%;" [nzShowToday]="false" #dateObj [nzRenderExtraFooter]="fcbutton"  *ngIf="fcMode==='day'" [nzAllowClear]="fcAllowClear==='Y'" 
            [ngClass]="{'fc-readonly':_readonly===true,'fc-date-small':fcSize === 'small','fc-date-default':fcSize === 'default','fc-date-large':fcSize === 'large'}" 
            [(ngModel)]="innerValue" (ngModelChange)="checkValidator($event)" [nzDisabledDate]="_disabledDate"  
                [nzPlaceHolder]="fcPlaceHolder" [nzFormat]="fcFormat" [nzSize]="fcSize" 
                [nzDisabled]="_disabled"  (blur)="_blur($event)" (focus)="_focus($event)"  (click)="_click($event)" (keyup)="_keyup($event)" ></nz-date-picker>
            <div class="fc-help-text" *ngIf="'Y'===fcShowHelp">
                {{fcHelp}}
            </div>
            <div class="explain" *ngIf="_validator!==undefined&&_validator.show==='Y'">
                <div [hidden]="_validator.showValidator!=='required'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.required}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='maxLength'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.maxLength}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='customVal'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.customVal}}</div>
                </div>
            </div>
        </div>
    </div>
    `,
    styles: [`
        .fc-readonly {
            pointer-events: none;
        }
        :host ::ng-deep .fc-readonly .ant-input{
            background-color: #f5f5f5;
        }
        .form-explain {
            position:relative;
        }
        .explain{
            white-space: nowrap;
            position:absolute;
            right: -1px;
            bottom: 24px;
            z-index:10;
        }
        .explain-inner {
            position:relative;
            color:red;
        }
        .explain-inner:after{
            content: '';
            width: 10px;
            height: 12px;
            display: block;
            background-color: #ffffff;
            border-right: 1px solid #e9e9e9;
            border-bottom: 1px solid #e9e9e9;
            position: absolute;
            bottom: -6px;
            right: 12px;
            transform: rotate(45deg);
            z-index: 0;
        }
        .explain-tips{
            padding: 0px 10px;
            background-color: #ffffff;
            border: 1px solid #e9e9e9;
            border-radius: 4px;
            font-size: 12px;
            height: 30px;
            line-height: 28px;
        }
        `
    ],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FcdateComponent),
        multi: true
    }]
})
export class FcdateComponent extends FcinputComponent {
    @Input()
    fcShowOk: string;
    @ViewChild('dateObj', {static: false})
    fcDateObj: any;
    @Input()
    fcOpen: boolean;
    @Input()
    fcAllowClear: string;
    /**æå¤©ä¹å*/
    @Input()
    fcBefore: string;
    /**æå¤©ä¹å*/
    @Input()
    fcAfter: string;
    /**æ¨¡å¼:éæ©å°å¤©ä¸ºdayï¼éæ©å°æä¸ºmonthï¼*/
    @Input()
    fcMode: string;
    /**æ¥ææ ¼å¼ é»è®¤yyyy-MM-ddï¼yyyyï¼å¹´ï¼MMï¼æï¼ddï¼å¤©ï¼yyyy-MM-dd | yyyy/MM/dd */
    @Input()
    fcFormat: string;
    /**è¾å¥æç¤ºç¬¦*/
    @Input()
    fcPlaceHolder: string;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-date');
        this._innerValue = null;
        if (this.fcMode === undefined) {
            this.fcMode = FCDATEMODE.day;
        }
        if (this.fcFormat === undefined) {
            this.fcFormat = 'yyyy-MM-dd';
        }
        if (this.fcPlaceHolder === undefined) {
            this.fcPlaceHolder = 'éæ©æ¥æ';
        }

    }
    ngOnChanges(param) {
        super.ngOnChanges(param);
    }
    _afterParentInit() {
        if (this.fcFormat === undefined) {
            switch (this.fcMode) {
                case FCDATEMODE.year:
                    this.fcFormat = "yyyy";
                    this.fcPlaceHolder = 'éæ©å¹´åº¦';
                    break;
                case FCDATEMODE.month:
                    this.fcFormat = "yyyy-MM";
                    this.fcPlaceHolder = 'éæ©æä»½';
                    break;
                default:
                    this.fcFormat = 'yyyy-MM-dd';
                    this.fcPlaceHolder = 'éæ©æ¥æ';
            }
        }
        if (!this.fcAllowClear) {
            this.fcAllowClear = 'Y';
        }


        /**æ¯å¦ç¦ç¨*/
        if (this.fcDisabled === 'Y') {
            this._disabled = true;
        } else {
            this._disabled = false;
        }
        /**æ¯å¦åªè®*/
        if (this.fcReadonly === 'Y') {
            this._readonly = true;
        } else {
            this._readonly = false;
        }
    }
    /**
     * å½æ°è¯´æï¼å¤§äºæä¸ªæ¶é´çç¦æ­¢éæ©
     */
    _disabledDate = (param: any): boolean => {
        let flag:boolean = false;
        if (this.fcBefore !== undefined) {
            let beforeDate = CommonService.getTimestampFromDate(this.fcBefore.replace(/-/g, "/")+" 23:59:59");
            flag = param && param.getTime() > beforeDate * 1000;
        }
        if (flag ==false && this.fcAfter !== undefined) {
            let afterDate = CommonService.getTimestampFromDate(this.fcAfter.replace(/-/g, "/")+" 00:00:00");
            flag =  param && param.getTime() < afterDate * 1000;
        }
        return flag;
    }
    clickOk(event, value): void {
        let dom = document.getElementsByClassName('ant-calendar-selected-day')[0] as HTMLCanvasElement
        let childDom = dom.querySelector('.ant-calendar-date') as HTMLCanvasElement
        childDom.click();
    }

}
/**
 * éæ©çæ¨¡å¼
 */
export const FCDATEMODE = {
    day: 'day',
    month: 'month',
    year: 'year'
}

